// extracted by mini-css-extract-plugin
export default {"root":"DoughnutChart_root__4vWxx","dashBoardWrapper":"DoughnutChart_dashBoardWrapper__3XnPo"};